// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*eslint-disable*/
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router';
import './assets/style/app.scss';
import Auth from './services/AuthService';

var Promise = require('es6-promise');
Promise.polyfill();
// eslint-disable-next-line
Office.initialize = function (reason) {
    // eslint-disable-next-line
    if (!isAppLoaded) {
        // eslint-disable-next-line
        isAppLoaded = true;

        Vue.config.productionTip = false;

        Vue.use(VueAxios, axios);
        // eslint-disable-next-line
        axios.defaults.headers.common['Authorization'] = Auth.getToken();

        router.beforeEach((to, from, next) => {
            if (to.matched.some(record => record.meta.requiresAuth)) {
                if (!Auth.getToken() && !Auth.expirationCheck()) {
                    next({
                        path: '/',
                        query: { redirect: to.fullPath }
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        });
        // eslint-disable-next-line
        new Vue({
            el: '#app',
            router,
            template: '<App/>',
            components: { App }
        });
    }
};
/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js